import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

import PolishAreaContent from './components/PolishAreaContent.vue';
import TooltipContent from './components/TooltipContent.vue';
import { ref, reactive, onMounted, nextTick, watch, onUnmounted } from 'vue';
import { fetchUpdateGrammar, fetchUpdateTone } from '@/request/aiAction';
import { createPopper, VirtualElement } from '@popperjs/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  selectedText: {
    type: String,
    required: true,
  },
  showGenerateImage: {
    type: Boolean,
    default: false,
  },
},
  emits: ['insert', 'replace', 'generateImage'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const props = __props;

const popperInstance = ref<any>(null); // 用于存储popper实例
const tooltip = ref<any>(null); // 用于存储tooltip实例
const isPolish = ref(false); // 用于显示润色区域
const polishTitle = ref(''); // 用于显示润色区域
const commandStr = ref(''); // 用于显示润色区域
const polishAreaLoading = ref(false); // 用于显示润色区域
const embellishType = ref('grammar'); // 用于修饰类型

// 虚拟元素
const virtualElement: VirtualElement = {
  getBoundingClientRect: generateGetBoundingClientRect(),
};

const isVisible = ref(false);

const tooltipRef = ref<HTMLElement | null>(null);
const tooltipWidth = ref(0);

// 挂载
onMounted(async () => {
  await nextTick();
  tooltip.value = document.querySelector('#tooltip');
  tooltipRef.value = tooltip.value;

  // Get the width of the tooltip
  if (tooltipRef.value) {
    tooltipWidth.value = tooltipRef.value.offsetWidth;
  }

  popperInstance.value = createPopper(virtualElement, tooltip.value, {
    strategy: 'fixed',
    placement: 'bottom',
    modifiers: [
      {
        name: 'appendTo',
        options: {
          element: document.body,
        },
      },
      {
        name: 'offset',
        options: {
          offset: [0, 6],
        },
      },
    ],
  });
});

// 生成图片
const handleGenerateImage = () => {
  emits('generateImage');
};

// 插入文本
const handleInsert = () => {
  emits('insert', { content: commandStr.value });
};

// 替换文本
const handleReplace = () => {
  emits('replace', { content: commandStr.value });
};

// 刷新
const handleRefresh = () => {
  // commandStr.value = "";
  handleUpdateSyntax(polishTitle.value, embellishType.value);
};

// 生成虚拟元素的getBoundingClientRect函数
function generateGetBoundingClientRect(x = 0, y = 0) {
  return () => ({
    width: 0,
    height: 0,
    top: y,
    right: x,
    bottom: y,
    left: x,
    x: x,
    y: y,
    toJSON: () => {},
  });
}

// 生成虚拟元素的getBoundingClientRect函数
const handleGenerateGetBoundingClientRect = (x: number, y: number) => {
  virtualElement.getBoundingClientRect = generateGetBoundingClientRect(x, y);
  popperInstance.value.update();
};

// 显示popper
const showPopper = () => {
  isVisible.value = true;
  nextTick(() => {
    tooltip.value.setAttribute('data-show', '');
    // 启用事件侦听器
    popperInstance.value.setOptions((options: any) => ({
      ...options,
      modifiers: [...options.modifiers, { name: 'eventListeners', enabled: true }],
    }));
    // 更新位置
    popperInstance.value.update();
  });
};

// 隐藏popper
const hidePopper = () => {
  isVisible.value = false;
  isPolish.value = false;
  tooltip.value.removeAttribute('data-show');
  // 禁用事件侦听器
  popperInstance.value.setOptions((options: any) => ({
    ...options,
    modifiers: [...options.modifiers, { name: 'eventListeners', enabled: false }],
  }));
  // 更新位置
  popperInstance.value.update();
};

// 修正语法
const handleUpdateSyntax = async (requirements: string, type: string) => {
  console.log(requirements, type);
  embellishType.value = type;
  polishAreaLoading.value = true;
  polishTitle.value = requirements;
  commandStr.value = '';
  isPolish.value = true;
  const inputs = {
    content: props.selectedText,
    requirements: requirements,
  };
  // 封装请求体
  const requestBody = {
    inputs,
    response_mode: 'streaming',
    user: 'abc-123',
  };
  try {
    let response: Response | null = null;
    // response = await fetchUpdateGrammar(requestBody);
    if (embellishType.value === 'grammar') {
      // 润色
      response = await fetchUpdateGrammar(requestBody);
    } else {
      // 修饰
      response = await fetchUpdateTone(requestBody);
    }
    if (!response || !response.body) return;
    const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
    let firstResultReceived = false;
    let buffer = '';

    while (true) {
      if (!isPolish.value) {
        throw new Error('请求被取消');
      }
      const { value, done } = await reader.read();
      if (done) break;
      buffer += value;

      // 处理每一块数据
      const lines = buffer.split('\n');
      buffer = lines.pop() || ''; // 保留最后一个不完整的行

      for (const line of lines) {
        const cleanedValue = line.replace(/^data: /, '').trim();
        try {
          const json = JSON.parse(cleanedValue);
          if (json.data && json.data.text) {
            if (!firstResultReceived) {
              commandStr.value = ''; // 清空提示词
              firstResultReceived = true;
            }
            commandStr.value += json.data.text;
          }
        } catch (e) {
          // console.log("Error parsing JSON:", e);
        }
      }
    }
    polishAreaLoading.value = false;
  } catch (err) {
    // 结束请求
    polishAreaLoading.value = false;
    // console.log(err);
  }
};

__expose({
  showPopper,
  hidePopper,
  handleGenerateGetBoundingClientRect,
  tooltipWidth,
  isVisible,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        id: "tooltip",
        role: "tooltip",
        class: "ai-polisher-tooltip",
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        ref_key: "tooltipRef",
        ref: tooltipRef
      }, [
        (!isPolish.value)
          ? (_openBlock(), _createBlock(TooltipContent, {
              key: 0,
              showGenerateImage: __props.showGenerateImage,
              onUpdateSyntax: handleUpdateSyntax,
              onHidePopper: hidePopper,
              onGenerateImage: handleGenerateImage
            }, null, 8, ["showGenerateImage"]))
          : _createCommentVNode("", true),
        (isPolish.value)
          ? (_openBlock(), _createBlock(PolishAreaContent, {
              key: 1,
              polishTitle: polishTitle.value,
              commandStr: commandStr.value,
              onInsert: handleInsert,
              onReplace: handleReplace,
              onRefresh: handleRefresh
            }, null, 8, ["polishTitle", "commandStr"]))
          : _createCommentVNode("", true)
      ], 544), [
        [_vShow, isVisible.value]
      ])
    ]),
    _: 1
  }))
}
}

})